import { AxiosResponse } from "axios";
import { route } from "../../../../shim/jsbridge";
import {
  JoeBehaviorGraphItem,
  JoeGeneralInfo,
  JoeProcessTree
} from "../../@types";
import { AxiosApiWrapper } from "../../../../services/api/AxiosApiWrapper";

class Api extends AxiosApiWrapper {
  getGeneralInfo = (
    hash?: string,
    uploadId?: string
  ): Promise<AxiosResponse<JoeGeneralInfo>> =>
    this.get(
      hash
        ? route("api_joe_general_info", [hash])
        : route("api_joe_general_info_url", [uploadId])
    );

  getBehaviorProcessTree = (
    hash?: string,
    uploadId?: string
  ): Promise<AxiosResponse<JoeProcessTree>> =>
    this.get(
      hash
        ? route(`api_joe_behavior_processtree`, [hash])
        : route(`api_joe_url_behavior_processtree`, [uploadId])
    );

  getBehaviorGraph = (
    hash?: string,
    uploadId?: string
  ): Promise<AxiosResponse<JoeBehaviorGraphItem[]>> =>
    this.get(
      hash
        ? route(`api_joe_behavior_graph`, [hash])
        : route(`api_joe_url_behavior_graph`, [uploadId])
    );
}

export default new Api();
